import { render, staticRenderFns } from "./CryptoBind.vue?vue&type=template&id=d82fa184&scoped=true"
import script from "./CryptoBind.vue?vue&type=script&lang=js"
export * from "./CryptoBind.vue?vue&type=script&lang=js"
import style0 from "./CryptoBind.vue?vue&type=style&index=0&id=d82fa184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82fa184",
  null
  
)

export default component.exports